var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social icon",
    clipPath: "url(#clip0_717_13475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.805 10.2312C19.805 9.55141 19.7499 8.86797 19.6323 8.19922H10.2V12.05H15.6014C15.3773 13.292 14.6571 14.3907 13.6025 15.0888V17.5874H16.825C18.7173 15.8457 19.805 13.2736 19.805 10.2312Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1999 20.0017C12.897 20.0017 15.1714 19.1162 16.8286 17.5876L13.6061 15.089C12.7096 15.699 11.5521 16.0444 10.2036 16.0444C7.59474 16.0444 5.38272 14.2843 4.58904 11.918H1.26367V14.4938C2.96127 17.8706 6.41892 20.0017 10.1999 20.0017Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.5854 11.9163C4.16651 10.6743 4.16651 9.32947 4.5854 8.0875V5.51172H1.2637C-0.154633 8.33737 -0.154633 11.6664 1.2637 14.4921L4.5854 11.9163Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.1999 3.95805C11.6256 3.936 13.0035 4.47247 14.036 5.45722L16.8911 2.60218C15.0833 0.904587 12.6838 -0.0287217 10.1999 0.000673888C6.41892 0.000673888 2.96126 2.13185 1.26367 5.51234L4.58537 8.08813C5.37537 5.71811 7.59106 3.95805 10.1999 3.95805Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_717_13475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.97970b8544a915fcc1bddb452a753d46.svg";
export { ForwardRef as ReactComponent };